<template>
<sc-page-base
  :title="changeTitle"
  :loading="loading">
  <sc-form
    :form="productGroup"
    :rules="rules"
    @submit="save">
    <template slot="fields" slot-scope="{ fields }">
      <div class="columns">
        <div class="column is-narrow">
            <sc-field
              label="Nome"
              prop="name">
                <sc-input
                v-model="fields.name"
                  class="is-narrow"
                  placeholder="Digite o nome do Grupo">
                </sc-input>
            </sc-field>
        </div>
        <div>
          <sc-field
            label="Skus"
            prop="skus"
            class="column">
              <sc-taginput
                v-model="fields.skus"
                placeholder="Digite os skus"
                :on-paste-separators="[',', ' ']"
                :maxtags="5000" />
          </sc-field>
        </div>
      </div>
    </template>

    <template slot="actions" slot-scope="{ isValid }">
      <router-link
          class="button is-active"
          :to="{ name: 'productGroups' }">
          Voltar
        </router-link>
         <sc-button
          type="submit"
          :disabled="!isValid"
          theme="primary"
          text="Salvar" />
    </template>
  </sc-form>
</sc-page-base>

</template>
<script>
  import {
    ScPageBase,
    ScForm,
    ScInput,
    ScTaginput,
    ScField,
    ScButton,
  } from '@intelipost-js/secure-components';

import { createNamespacedHelpers } from 'vuex';

  const { mapState, mapActions, mapMutations } = createNamespacedHelpers('quote/productGroups');

  export default {
    name: 'page-product-group-manage',
    data() {
      return {
        rules: {
          name: [{
            required: true,
            min: 0,
            message: 'Preencha o campo Nome',
            trigger: 'input',
          }],
          skus: [{
            required: true,
            message: 'Informe o Sku do produto',
          }],
        },
      };
    },
    computed: {
      ...mapState([
        'loading',
        'productGroups',
        'productGroup',
      ]),
      isCreating() {
        const { id = null } = this.$route.params;

        return id === null;
      },
      changeTitle() {
        return `${this.isCreating ? 'Adicionar' : 'Editar'} grupo de produtos`;
      },
    },
    methods: {
      ...mapMutations([
        'setProductGroup',
      ]),
      ...mapActions([
        'saveGroup',
        'getProductGroup',
      ]),
      save(params) {
        return this.saveGroup(params).then(() => {
          this.$router.push({
            name: 'productGroups',
          });
        });
      },
    },
    beforeMount() {
      const { id = null } = this.$route.params;
      this.setProductGroup({});

      if (id) {
        this.getProductGroup(id);
      }
    },
    components: {
      ScPageBase,
      ScForm,
      ScInput,
      ScTaginput,
      ScField,
      ScButton,
    },
  };
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-quote/features/product-groups/pages/product-group-manage/PageProductGroupManage.vue?1fb96918